import { render, staticRenderFns } from "./ReportDetailsModal.vue?vue&type=template&id=3bdcfbf5&scoped=true&"
import script from "./ReportDetailsModal.vue?vue&type=script&lang=js&"
export * from "./ReportDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./ReportDetailsModal.vue?vue&type=style&index=0&id=3bdcfbf5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdcfbf5",
  null
  
)

export default component.exports